<template>
  <a-row>
    <a-col>
      <profile-card
        :person="personModel"
        :avatar="avatarModel"
        @update="updateProfile"
      />
    </a-col>

    <a-col :span="16">
      <a-row>
        <div class="profile-info">
          <h2>
            {{ personModel.lastName }} {{ personModel.firstName }}
            {{ personModel.middleName }}
          </h2>
          <div v-if="!personModel.isStudent" class="profile-info__position">
            <div
              v-if="!!personModel.position && !!personModel.pureOrganization"
            >
              {{ `${personModel.position}, ${personModel.pureOrganization}` }}
            </div>
          </div>
          <div class="profile-info-about" v-if="personModel.about">
            <div class="profile-info-about__label">О себе:</div>
            <div class="profile-info-about__content">
              {{ personModel.about }}
            </div>
          </div>
        </div>
      </a-row>

      <profile-student-horizontal-filter v-if="personModel?.isStudent" />
      <profile-horizontal-filter v-else />

      <slot></slot>
    </a-col>
  </a-row>
</template>

<script setup>
  import { onMounted, reactive } from 'vue';
  import { useApi } from '@/api/use-api';
  import ProfileCard from '@/views/profile/components/ProfileCard.vue';
  import ProfileHorizontalFilter from '@/views/profile/components/ProfileHorizontalFilter.vue';
  import ProfileStudentHorizontalFilter from '@/views/profile/components/ProfileStudentHorizontalFilter.vue';

  const emit = defineEmits(['update-person']);
  const api = useApi();
  const personModel = reactive({
    lastName: '',
    firstName: '',
    middleName: '',
    position: '',
    about: '',
    portfolioUrl: '',
    email: '',
    phone: '',
    whatsappId: '',
    telegramId: '',
    vkId: '',
    isVisibleToPartner: false,
    isStudent: true,
    pureOrganization: '',
  });
  const avatarModel = reactive({
    personId: 0,
    attachmentUid: '',
  });

  onMounted(async () => {
    await updateProfile();
  });

  async function updateProfile() {
    try {
      const response = await api.person.profile();
      personModel.lastName = response.person.lastName;
      personModel.firstName = response.person.firstName;
      personModel.middleName = response.person.middleName;
      personModel.position = response.person.position;
      personModel.email = response.person.email;
      personModel.phone = response.person.phone;
      personModel.about = response.person.about;
      personModel.portfolioUrl = response.person.portfolioUrl;
      personModel.whatsappId = response.person.whatsappId;
      personModel.telegramId = response.person.telegramId;
      personModel.vkId = response.person.vkId;
      personModel.isVisibleToPartner = response.person.isVisibleToPartner;
      personModel.isStudent = response.person.isStudent;
      personModel.pureOrganization = response.person.pureOrganization;
      avatarModel.personId = response.person.personId;
      avatarModel.attachmentUid = response.person.attachmentUid;

      emit('update-person', personModel);
    } catch (error) {
      console.error('error', error);
    }
  }
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_breakpoints.scss' as *;
  @use '@/assets/styles/_colors.scss' as *;

  h4 {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }

  .profile-info {
    max-width: 850px;

    @include breakpoint(min, 1344px) {
      min-height: 200px;
    }

    & h2 {
      margin-bottom: 10px;
    }

    &__position {
      font-size: 14px;
      color: #949fb0;
      margin-bottom: 20px;
    }

    .profile-info-about {
      &__label {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 5px;
      }

      &__content {
        font-size: 14px;
        word-wrap: break-word;
        overflow-wrap: break-word;
        white-space: normal;
      }
    }
  }

  .profile-horizontal-filter {
    margin: 30px 0;

    .horizontal-filter {
      margin: 0;
    }
  }

  .divider {
    margin: 25px 0 25px 0;
  }
</style>
